import { env } from './env';

class Analytics {
  lxCommonParams() {
    return {
      scene: env.scene || '-999',
      utm_source: env.utmSource || '-999',
      from: env.scene || '-999',
    };
  }

  pv(cid: any, lab = {}) {
    if ('LXAnalytics' in window && cid) {
      (window as any).LXAnalytics(
        'pageView',
        {
          custom: {
            ...this.lxCommonParams(),
            ...lab,
          },
        },
        cid
      );
    }
  }

  click(bid: any, lab = {}) {
    if ('LXAnalytics' in window && bid) {
      (window as any).LXAnalytics('moduleClick', bid, {
        ...this.lxCommonParams(),
        ...lab,
      });
    }
  }

  mv(bid: string, lab = {}, cid = '') {
    if ('LXAnalytics' in window && bid) {
      (window as any).LXAnalytics(
        'moduleView',
        bid,
        {
          ...this.lxCommonParams(),
          ...lab,
        },
        {
          cid,
        }
      );
    }
  }

  addTag(tagObj: any, cid: string) {
    const options = {
      [cid]: {
        ...tagObj,
      },
    };
    (window as any).LXAnalytics('tag', 'pay', options);
  }

  bo(bid: string, orderId: string) {
    (window as any).LXAnalytics(
      'order',
      bid,
      orderId,
      {
        ...this.lxCommonParams(),
      },
      {}
    );
  }
}

export const analytics = new Analytics();
